const initAssets = {
  assets_count: 0,
  invested: 0,
  total_income: 0,
  total_rwa: 0,
  assets: null,
};

function initState() {
  return {
    locations: [],
    objects: [],
    history: [],
    assets: initAssets,
    catalog: [],
    favorites: [],
    objectId: null,
    balance: 0,
  };
}

const state = initState();

const mutations = {
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
  SET_OBJECTS(state, objects) {
    state.objects = objects;
  },
  SET_ASSETS(state, assets) {
    state.assets = assets;
  },
  SET_HISTORY(state, history) {
    state.history = history;
  },
  SET_CATALOG(state, catalog) {
    state.catalog = catalog;
  },
  SET_FAVORITES(state, favorites) {
    state.favorites = favorites;
  },
  SET_OBJECT_ID(state, objectId) {
    state.objectId = objectId;
  },
  SET_BALANCE(state, balance) {
    state.balance = balance;
  },
};

const actions = {
  async GET_OBJECTS({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/list?${query}`;

    try {
      const { list } = await this.$customApiService().get(url);
      commit("SET_OBJECTS", list ?? []);

      return Promise.resolve(list);
    } catch (error) {
      commit("SET_OBJECTS", []);

      return Promise.reject(error);
    }
  },

  async GET_ASSETS({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/me/assets?${query}`;

    try {
      const assets = await this.$customApiService().get(url);
      commit("SET_ASSETS", assets);

      return Promise.resolve(assets);
    } catch (error) {
      commit("SET_ASSETS", initAssets);

      return Promise.reject(error);
    }
  },

  async HISTORY({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/history?${query}`;

    try {
      const response = await this.$customApiService().get(url);
      commit("SET_HISTORY", response ?? []);

      return Promise.resolve(response);
    } catch (error) {
      commit("SET_HISTORY", []);

      return Promise.reject(error);
    }
  },

  async GET_LOCATIONS({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/locations?${query}`;

    try {
      const locations = await this.$customApiService().get(url);
      commit("SET_LOCATIONS", locations);

      return Promise.resolve(locations);
    } catch (error) {
      commit("SET_LOCATIONS", []);

      return Promise.reject(error);
    }
  },

  async GET_CATALOG({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/showcase?${query}`;

    try {
      const response = await this.$customApiService().get(url);
      commit("SET_CATALOG", response ?? []);

      return Promise.resolve(response ?? []);
    } catch (error) {
      commit("SET_CATALOG", []);

      return Promise.reject(error);
    }
  },

  async GET_FAVORITES({ commit }, params) {
    const query = new URLSearchParams(params);
    const url = `/rwa/showcase?${query}`;

    try {
      const response = await this.$customApiService().get(url);
      commit("SET_FAVORITES", response ?? []);

      return Promise.resolve(response ?? []);
    } catch (error) {
      commit("SET_FAVORITES", []);

      return Promise.reject(error);
    }
  },

  async FAVORITE(_, rwa_id) {
    try {
      const response = await this.$customApiService().post("/rwa/favorite", {
        rwa_id,
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_OBJECT(_, { id, ...params }) {
    const query = new URLSearchParams(params);
    const url = `/rwa/product/${id}?${query}`;

    try {
      const response = await this.$customApiService().get(url);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async INVEST(_, request) {
    try {
      const response = await this.$customApiService().post(
        "/rwa/invest",
        request,
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
